/* eslint-disable camelcase */

import { TeamType } from "@teaming/common-enums";

const ACTIVITY_EVENT_NAME = "Shared Note Activity Initiated";

const mapActivityArgs = ( {
	initiatorId = "",
	initiatorName = "",
	thisMemberRole = "",
	isThisMemberInitiator = true,
	teamType = "",
	teamId = "",
	teamName = "",
	isSampleTeam = false,
	noteTimestamp = "",
	noteName = "",
	noteDeepLink = "",
} ) => ( {
	initiator_person_id: initiatorId, // (the person id of the creator)
	initiator_name: initiatorName, // (full name of the user creating the content)
	this_member_role: thisMemberRole, // (LEAD | MEMBER | MANAGER | REPORT | PEER)
	did_this_member_initiate_activity: isThisMemberInitiator ? "TRUE" : "FALSE",
	team_type: teamType, // (TEAM | 1:1)
	team_id: teamId,
	team_display_name: teamName,
	is_sample_one_on_one: isSampleTeam ? "TRUE" : "FALSE",
	shared_note_datetime: noteTimestamp, // (associated date/time of this note)
	associated_note_name: noteName, // (title of the shared note)
	associated_deep_link: noteDeepLink, // (the deep link directly to the shared note)
} );

// eslint-disable-next-line no-unused-vars
export default ( { currentUser, amplitude, intercom, } ) => {
	return {
		streamNoteCreated( activityArgs ) {
			return intercom.trackEvent( ACTIVITY_EVENT_NAME, {
				...mapActivityArgs( activityArgs ),
				action_type: "CREATED",
			} );
		},
		streamNoteDateModified( activityArgs ) {
			return intercom.trackEvent( ACTIVITY_EVENT_NAME, {
				...mapActivityArgs( activityArgs ),
				action_type: "DATE_MODIFIED",
			} );
		},
		streamNoteTitleModified( activityArgs ) {
			return intercom.trackEvent( ACTIVITY_EVENT_NAME, {
				...mapActivityArgs( activityArgs ),
				action_type: "TITLE_MODIFIED",
			} );
		},
		streamNoteTopicAdded( activityArgs ) {
			return intercom.trackEvent( ACTIVITY_EVENT_NAME, {
				...mapActivityArgs( activityArgs ),
				action_type: "TOPICS_ADDED",
			} );
		},
		streamNoteContentModified( activityArgs ) {
			return intercom.trackEvent( ACTIVITY_EVENT_NAME, {
				...mapActivityArgs( activityArgs ),
				action_type: "CONTENT_MODIFIED",
			} );
		},
		streamNoteDeleted( activityArgs ) {
			return intercom.trackEvent( ACTIVITY_EVENT_NAME, {
				...mapActivityArgs( activityArgs ),
				action_type: "DELETED",
			} );
		},
		streamNoteTemplateSelected( {
			thisMemberRole = "", // (LEAD | MEMBER | MANAGER | REPORT | PEER)
			teamId = "",
			teamName = "",
			templateName = "", // (the name of the selected template)
			templateType = "", // (TEAM | 1:1)
			isSampleTeam = false,
			noteName = "", // (title of the shared note)
			noteDeepLink = "", // (the deep link directly to the shared note created/applied)
		} ) {
			return intercom.trackEvent( "Meeting Template Selected", {
				this_member_role: thisMemberRole,
				team_id: teamId,
				team_display_name: teamName,
				template_name: templateName,
				template_type: templateType,
				is_sample_one_on_one: isSampleTeam ? "TRUE" : "FALSE",
				associated_note_name: noteName,
				associated_deep_link: noteDeepLink,
			} );
		},
		streamNoteSummaryFeedbackSubmitted( {
			submitterName = "",
			teamId = "",
			teamType = "",
			subDocId = "",
			transcriptionJobId = "",
			rating = -1,
			feedbackComment = "",
		} ) {
			if ( teamType === TeamType.ONE_ON_ONE ) {
				teamType = "1:1";
			}

			let feedbackReaction = "indeterminate";
			if ( rating === 1 ) {
				feedbackReaction = "up";
			}
			if ( rating === 0 ) {
				feedbackReaction = "down";
			}

			return intercom.trackEvent( "Meeting Summary Feedback Submitted", {
				submitter_name: submitterName,
				team_id: teamId,
				team_type: teamType,
				sub_doc_id: subDocId,
				transcription_job_id: transcriptionJobId,
				feedback_reaction: feedbackReaction,
				feedback_comment: feedbackComment,
			} );
		},
	};
};
